import { useTranslation } from "react-i18next";
import { Box, Typography, Skeleton, Divider } from "@mui/material";

import { ExperienceIcon } from "../../assets/icons/player-icons";

import { styles } from "./styles";

export const ExperienceLoader = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "experience" });

  const ExperienceItemLoader = () => (
    <Box sx={{ display: "flex", flexDirection: "column", rowGap: "8px" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <Skeleton variant="circular" width={40} height={40} />
        <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          <Skeleton variant="text" width={120} height={20} />
          <Skeleton variant="text" width={80} height={18} />
        </Box>
      </Box>
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: "24px" }}>
        <Box sx={{ paddingLeft: "16px" }}>
          <ExperienceIcon />
        </Box>
        <Box sx={{ display: "flex", gap: "24px", paddingTop: "20px" }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            <Skeleton variant="text" width={80} height={20} />
            <Skeleton variant="text" width={60} height={18} />
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: "24px", height: "fit-content" }}>
            <Skeleton variant="text" width={60} height={18} />
            <Divider orientation="vertical" flexItem />
            <Skeleton variant="text" width={60} height={18} />
          </Box>
          <Skeleton variant="text" width={30} height={18} />
        </Box>
      </Box>
    </Box>
  );

  return (
    <Box sx={styles.container}>
      <Typography sx={styles.title}>{t("experience")}</Typography>
      <Box sx={{ display: "flex", flexDirection: "column", rowGap: "16px" }}>
        <Skeleton variant="text" width={80} height={20} />
        {[1, 2].map((item) => (
          <ExperienceItemLoader key={item} />
        ))}
        <Skeleton variant="text" width={100} height={20} />
        <ExperienceItemLoader />
      </Box>
    </Box>
  );
};
